const config = {
  active: {
    label: "Active",
    background: "bg-emerald-100",
    text: "text-emerald-700",
  },
  disabled: {
    label: "Disabled",
    background: "bg-rose-100",
    text: "text-rose-700",
  },
};

export default function UserStatusBadge({ isActive = true }) {
  const status = isActive ? config.active : config.disabled;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide ${status.background} ${status.text}`}
    >
      {status.label}
    </span>
  );
}
